export const CustomerReport = () => {

    return ( 
        <div>
            Customer Report Page
        </div>
    )
}